import { mapPageTestIDs } from '@constants';
import { ChangeMapModalPage, MapPage } from '@screens';

export const excludeTVOSScreens = [
  {
    component: MapPage,
    name: mapPageTestIDs.mapPage,
  },
  {
    component: ChangeMapModalPage,
    name: mapPageTestIDs.changeMapPage,
    options: {
      presentation: 'transparentModal',
      detachPreviousScreen: false,
      anfCanOverride: false,
      alertsCanOverride: false,
    },
  },
];
